module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col grid rankview"
  }, [_c('table', {
    staticClass: "col-2 ranker"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rankers), function(ranker) {
    return _c('tr', {
      staticClass: "grid"
    }, [_c('td', {
      staticClass: "col"
    }, [_c('router-link', {
      attrs: {
        "to": ("/profile/" + (ranker.profile.uid) + "/")
      }
    }, [_vm._v(_vm._s(ranker.profile.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_vm._v(_vm._s(ranker.rate))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col board"
  }, [_c('table', {
    style: ({
      width: _vm.proitems.length * 60 + 'px'
    })
  }, [_c('thead', [_c('tr', _vm._l((_vm.proitems), function(proitem) {
    return _c('th', [_c('router-link', {
      attrs: {
        "to": ("/problem/" + (proitem.problem.uid) + "/")
      }
    }, [_vm._v(_vm._s(proitem.problem.uid))])], 1)
  })), _vm._v(" "), _c('tr', _vm._l((_vm.proitems), function(proitem) {
    return _c('td', [_vm._v(_vm._s(proitem.sumscore))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rankers), function(ranker) {
    return _c('tr', _vm._l((_vm.proitems), function(proitem) {
      return _c('td', [_vm._v(_vm._s(_vm.getResult(ranker.results[proitem.problem.uid])))])
    }))
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col"
  }, [_vm._v("Ranker")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Rate")])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v(" ? ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1510bbeb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RankView.vue
// module id = 573
// module chunks = 0